import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import confirm from './plugins/confirm'
import scrollToAddedSection from './plugins/scrollToAddedSection'
import processIndicator from './plugins/processIndicator'
import { registerServiceWorker } from './services/pwaService'

import 'bootstrap/js/dist/dropdown'
import 'jodit/build/jodit.min.css'
import '@fortawesome/fontawesome-free/css/all.css'

window.$ = window.jQuery = require('jquery')

store.dispatch('initAuth')
  .finally(() => {
    createApp(App)
      .use(router)
      .use(store)
      .use(confirm)
      .use(scrollToAddedSection)
      .use(processIndicator, { store })
      .mount('#app')

    registerServiceWorker()
  })
